import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import AppContainer from "./components/AppContainer";
import CreateStudy from "./components/study-creation/CreateStudy";
import ChooseNumberOfQuestions from "./components/study-creation/ChooseNumberOfQuestions";
import Questions from "./components/study-creation/Questions";
import AnswersOfQuestionN from "./components/study-creation/AnswersOfQuestionN";
import SegmentQuestion from "./components/study-creation/SegmentQuestion";
import OpenEndedQuestion from "./components/study-creation/OpenEndedQuestion";
import RespondentOrientation from "./components/study-creation/RespondentOrientation";
import RatingScale from "./components/study-creation/RatingScale";
import FinalThoughts from "./components/study-creation/FinalThoughts";
import DoneCreatingStudy from "./components/study-creation/DoneCreatingStudy";
import ChooseSourcingMethod from "./components/study-creation/ChooseSourcingMethod";
import StudyContainer from "./components/study-creation/StudyContainer";
import Home from "./components/Home";
import AuthenticatedContainer from "./components/AuthenticatedContainer";
import Dashboard from "./components/Dashboard";
import SignUp from "./components/SignUp";
import ResultsContainer from "./components/ResultsContainer";
import MyProfile from "./components/views/MyProfile";
import SurveyPublicLoading from "./components/survey/SurveyPublicLoading";
import Browse from "./components/views/Browse";
import PublicStudy from "./components/views/PublicStudy";
import PresentationMedia from "./components/study-creation/PresentationMedia";
import PostPresentationMedia from "./components/study-creation/PostPresentationMedia";

import {
  A_PER_ROUTE_ACTIONS,
  R_NAME_CREATE_A_STUDY,
  R_NAME_CREATE_STUDY_CHOOSE_NUMBER_OF_QUESTIONS,
  R_NAME_CREATE_STUDY_QUESTIONS,
  R_NAME_CREATE_STUDY_ANSWERS_OF_QUESTION_N,
  R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N,
  R_NAME_CREATE_STUDY_OPEN_ENDED_QUESTION,
  R_NAME_CREATE_STUDY_RESPONDENT_ORIENTATION,
  R_NAME_CREATE_STUDY_RATING_SCALE,
  R_NAME_CREATE_STUDY_FINAL_THOUGHTS,
  R_NAME_CREATE_STUDY_DONE,
  R_NAME_MANAGE_STUDY_CHOOSE_SOURCING_METHOD,
  R_NAME_HOME,
  R_NAME_ABOUT,
  R_NAME_BROWSE,
  R_NAME_CONTACT,
  R_NAME_DASHBOARD,
  R_NAME_RESULTS,
  R_NAME_SIGN_UP,
  R_NAME_MY_PROFILE,
  R_NAME_SURVEY,
  R_NAME_PUBLIC_SURVEY,
  GET_IS_LOGGED_IN,
  R_NAME_PUBLIC_STUDY,
  R_NAME_BUY_STUDY,
  R_NAME_FLASH_RESULTS,
  R_NAME_CONFIRMATION_PAGE,
  R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE,
  R_NAME_PRIVACY,
  R_NAME_CREATE_STUDY_LOADING,
  R_NAME_SURVEY_PREVIEW,
  R_NAME_MANAGE_PARTICIPANTS,
  R_NAME_PUBLIC_STUDY_INFO,
  R_NAME_RAW_DATA,
  R_NAME_TERMS_OF_SERVICE,
  R_NAME_PURCHASES,
  R_NAME_PURCHASE,
  R_NAME_PURCHASE_FLASH,
  R_NAME_PASSWORD_RESET_PAGE,
  R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_QUESTION,
  R_NAME_CREATE_STUDY_TELL_US_WHO_YOU_ARE,
  R_NAME_CREATE_STUDY_PRESENTATION_MEDIA,
  R_NAME_CREATE_STUDY_POST_PRESENTATION_MEDIA, R_NAME_CREATE_STUDY_PRE_OPTIONAL_QUESTION,
} from "./services/constants";
import PublicResults from "./components/views/PublicResults";
import ConfirmationPage from "./components/views/ConfirmationPage";
import SurveyQualificationLanguage from "./components/study-creation/SurveyQualificationLanguage";
import About from "./components/views/About";
import Privacy from "./components/views/Privacy";
import CreateStudyLoading from "./components/views/CreateStudyLoading";
import Contact from "./components/views/Contact";
import SurveyPreview from "./components/survey/SurveyPreview";
import SurveyActual from "./components/survey/SurveyActual";
import ManageParticipants from "./components/views/ManageParticipants";
import StudyInfoContainer from "./components/views/StudyInfoContainer";
import RawData from "./components/views/RawData";
import TermsOfService from "./components/views/TermsOfService";
import PasswordResetPage from "./components/views/PasswordResetPage";
import SurveyQualificationQuestion from "./components/study-creation/SurveyQualificationQuestion";
import TellUsWhoYouAre from "./components/study-creation/TellUsWhoYouAre";
import PreOptionalQuestion from "@/components/study-creation/PreOptionalQuestion.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: AppContainer,
      children: [
        {
          path: "home",
          name: R_NAME_HOME,
          component: Home,
        },
        {
          path: "signup",
          name: R_NAME_SIGN_UP,
          component: SignUp,
        },
        {
          path: "edit/:id",
          meta: {
            editGroup: true,
          },
          component: AuthenticatedContainer,
          beforeEnter: (to, from, next) => {
            loginGuard(to, from, next);
          },
          children: [
            {
              path: "",
              component: StudyContainer,
              children: [
                {
                  path: "",
                  name: R_NAME_CREATE_A_STUDY,
                  component: CreateStudy,
                  // beforeEnter: (to, from, next) => {
                  //   createStudy(to, from, next)
                  // }
                },
                {
                  path: "grid",
                  name: R_NAME_CREATE_STUDY_CHOOSE_NUMBER_OF_QUESTIONS,
                  component: ChooseNumberOfQuestions,
                },
                {
                  path: "questions",
                  name: R_NAME_CREATE_STUDY_QUESTIONS,
                  component: Questions,
                },
                {
                  path: "answers/:n",
                  name: R_NAME_CREATE_STUDY_ANSWERS_OF_QUESTION_N,
                  component: AnswersOfQuestionN,
                },
                {
                  path: "classification/:n",
                  name: R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N,
                  component: SegmentQuestion,
                },
                {
                  path: "media",
                  name: R_NAME_CREATE_STUDY_PRESENTATION_MEDIA,
                  component: PresentationMedia,
                },
                {
                  path: "pre",
                  name: R_NAME_CREATE_STUDY_PRE_OPTIONAL_QUESTION,
                  component: PreOptionalQuestion,
                },
                {
                  path: "orientation",
                  name: R_NAME_CREATE_STUDY_RESPONDENT_ORIENTATION,
                  component: RespondentOrientation,
                },
                {
                  path: "rating",
                  name: R_NAME_CREATE_STUDY_RATING_SCALE,
                  component: RatingScale,
                },
                {
                  path: "post-media",
                  name: R_NAME_CREATE_STUDY_POST_PRESENTATION_MEDIA,
                  component: PostPresentationMedia,
                },
                {
                  path: "open",
                  name: R_NAME_CREATE_STUDY_OPEN_ENDED_QUESTION,
                  component: OpenEndedQuestion,
                },
                {
                  path: "final",
                  name: R_NAME_CREATE_STUDY_FINAL_THOUGHTS,
                  component: FinalThoughts,
                },
                {
                  path: "type",
                  name: R_NAME_CREATE_STUDY_TELL_US_WHO_YOU_ARE,
                  component: TellUsWhoYouAre,
                },
                {
                  path: "done",
                  name: R_NAME_CREATE_STUDY_DONE,
                  component: DoneCreatingStudy,
                },
                {
                  path: "sourcing",
                  name: R_NAME_MANAGE_STUDY_CHOOSE_SOURCING_METHOD,
                  component: ChooseSourcingMethod,
                },
                {
                  path: "qualifications/languages",
                  name: R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE,
                  component: SurveyQualificationLanguage,
                },
                {
                  path: "qualifications/:questionName",
                  name: R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_QUESTION,
                  component: SurveyQualificationQuestion,
                },
                {
                  path: "*",
                  redirect: {
                    name: R_NAME_DASHBOARD,
                  },
                },
              ],
            },
          ],
        },
        {
          path: "u",
          component: AuthenticatedContainer,
          beforeEnter: (to, from, next) => {
            loginGuard(to, from, next);
          },
          children: [
            {
              path: "dashboard",
              name: R_NAME_DASHBOARD,
              component: Dashboard,
            },
            {
              path: "purchases",
              name: R_NAME_PURCHASES,
              component: Dashboard,
            },
            {
              path: "myprofile",
              name: R_NAME_MY_PROFILE,
              component: MyProfile,
            },
            {
              path: "results/:id",
              name: R_NAME_RESULTS,
              component: ResultsContainer,
            },
            {
              path: "purchase/:id",
              name: R_NAME_PURCHASE,
              component: ResultsContainer,
            },
            {
              path: "purchase-flash/:id",
              name: R_NAME_PURCHASE_FLASH,
              component: PublicResults,
            },
            {
              path: "publicstudyinfo/:id",
              name: R_NAME_PUBLIC_STUDY_INFO,
              component: StudyInfoContainer,
            },
            {
              path: "manageparticipants/:id",
              name: R_NAME_MANAGE_PARTICIPANTS,
              component: ManageParticipants,
            },
            {
              path: "createStudyLoading",
              name: R_NAME_CREATE_STUDY_LOADING,
              component: CreateStudyLoading,
            },
            {
              path: "rawdata/:id",
              name: R_NAME_RAW_DATA,
              component: RawData,
            },
            {
              path: "*",
              redirect: {
                name: R_NAME_DASHBOARD,
              },
            },
          ],
        },
        {
          path: "",
          redirect: {
            name: R_NAME_DASHBOARD,
          },
        },
        {
          path: "about",
          name: R_NAME_ABOUT,
          component: About,
        },
        {
          path: "browse",
          name: R_NAME_BROWSE,
          component: Browse,
        },
        {
          path: "contact",
          name: R_NAME_CONTACT,
          component: Contact,
        },
        {
          path: "privacy",
          name: R_NAME_PRIVACY,
          component: Privacy,
        },
        {
          path: "lucid-tos",
          name: R_NAME_TERMS_OF_SERVICE,
          component: TermsOfService,
        },
        {
          path: "buy",
          name: R_NAME_BUY_STUDY,
        },
        {
          path: "result/:id",
          name: R_NAME_FLASH_RESULTS,
          component: PublicResults,
        },
        {
          path: "study/:study_id",
          name: R_NAME_PUBLIC_STUDY,
          component: PublicStudy,
        },
        {
          path: "user/confirm/:userID",
          name: R_NAME_CONFIRMATION_PAGE,
          component: ConfirmationPage,
        },
        {
          path: "user/reset-page/:token",
          name: R_NAME_PASSWORD_RESET_PAGE,
          component: PasswordResetPage,
        },
      ],
    },
    {
      path: "/survey/:survey_id",
      name: R_NAME_SURVEY,
      component: SurveyActual,
    },
    {
      path: "/survey/public/:study_id",
      name: R_NAME_PUBLIC_SURVEY,
      component: SurveyPublicLoading,
    },
    {
      path: "/survey/live/:study_id",
      name: R_NAME_PUBLIC_SURVEY,
      component: SurveyPublicLoading,
    },
    {
      path: "/survey/preview/:study_id",
      name: R_NAME_SURVEY_PREVIEW,
      component: SurveyPreview,
    },
  ],
});

router.afterEach((to, from) => {
  store.dispatch(A_PER_ROUTE_ACTIONS, to);
});

const loginGuard = (to, from, next) => {
  if (store.getters[GET_IS_LOGGED_IN]) {
    return next();
  }
  return next({
    name: R_NAME_HOME,
  });
};

export default router;
